var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable default-case */
import * as PasswordRecoveryActions from '../../actions/auth/Forgot';
import * as PasswordRecoveryStates from '../../constants/PasswordRecoveryState';
var initialState = {
    isOngoing: false,
    forgotModalToggled: false,
    state: null,
    email: undefined,
    phone: undefined,
    errorCode: undefined,
    smsRecoverModalToggled: false,
    smsRecoveryStatus: null,
    smsRecoveryConfirm: null,
    smsRecoveryError: null,
    login: null,
    statusState: null,
    uidConfirmState: null,
};
export default function (state, action) {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case PasswordRecoveryActions.SUCCESS_FETCH_UID_RECOVERY_CONFIRM:
            return __assign(__assign({}, state), { uidConfirmState: action.data.ResultState });
        case PasswordRecoveryActions.SUCCESS_FETCH_JOIN_STATUS:
            if (action.data.Login === undefined) {
                return __assign(__assign({}, state), { statusState: -2 });
            }
            else {
                return __assign(__assign({}, state), { login: action.data.Login, statusState: action.data.Status });
            }
        case PasswordRecoveryActions.OPEN_FORGOT_MODAL:
            return __assign(__assign({}, state), { state: null, forgotModalToggled: true });
        case PasswordRecoveryActions.CLOSE_FORGOT_MODAL:
            return __assign(__assign({}, state), { state: null, forgotModalToggled: false });
        case PasswordRecoveryActions.RECOVER_PASSWORD:
        case PasswordRecoveryActions.RECOVER_UZ_PASSWORD:
            return __assign(__assign({}, state), { state: null, uzResultState: null });
        case PasswordRecoveryActions.SUCCESS_RECOVER_PASSWORD:
            return __assign(__assign({}, state), { state: action.data.ResultState === 0 ? PasswordRecoveryStates.FINISH : action.data.ResultState, email: action.data.Email, phone: action.data.Phone, errorCode: action.data.ResultState, forgotModalToggled: action.data.Phone === undefined, smsRecoverModalToggled: action.data.Phone !== undefined });
        case PasswordRecoveryActions.SUCCESS_RECOVER_UZ_PASSWORD:
            var errorCode = 0;
            if (action.data.ResultState !== -1 || action.data.ResultState !== 0) {
                errorCode = action.data.ResultState;
            }
            return __assign(__assign({}, state), { state: action.data.ResultState === -1 ? PasswordRecoveryStates.FINISH : null, errorCode: errorCode, uzResultState: action.data.ResultState, smsRecoverModalToggled: action.data.ResultState === -1 ? true : false, forgotModalToggled: action.data.ResultState !== -1 ? true : false });
        case PasswordRecoveryActions.FAILURE_RECOVER_PASSWORD:
        case PasswordRecoveryActions.FAILURE_RECOVER_UZ_PASSWORD:
            return __assign(__assign({}, state), { errorCode: 500 });
        case PasswordRecoveryActions.SUCCESS_FETCH_SMS_RECOVERY_STATUS:
            if (action.data.ResultState === 0) {
                return __assign(__assign({}, state), { smsRecoveryStatus: 0, smsRecoveryError: null });
            }
            else if (action.data && action.data.Error) {
                return __assign(__assign({}, state), { smsRecoveryError: action.data.Error });
            }
            else {
                return __assign(__assign({}, state), { smsRecoveryError: action.data.ResultState });
            }
        case PasswordRecoveryActions.SUCCESS_FETCH_SMS_RECOVERY_CONFIRM:
            if (action.data.ResultState === 0) {
                return __assign(__assign({}, state), { smsRecoveryConfirm: 0 });
            }
            else {
                return state;
            }
        case PasswordRecoveryActions.CLOSE_SMS_RECOVER_MODAL:
            return __assign(__assign({}, state), { smsRecoverModalToggled: false });
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/auth/recoverReducer.js